import Vue from 'vue'
import VueRouter from 'vue-router'
import MainView from "../views/MainView";
import SuccessPage from "../views/SuccessPage"
import VueMeta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(VueMeta)

//Das hier raus; ich will language als Query; nicht als Parameter
  const routes = [
      {
        path: '/',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/completed',
        name: 'completed',
        component: SuccessPage
      }
]

const router = new VueRouter({
  routes
})

export default router
